import { render } from "./Recording.vue?vue&type=template&id=47e84ac6&scoped=true&ts=true"
import script from "./Recording.vue?vue&type=script&lang=ts"
export * from "./Recording.vue?vue&type=script&lang=ts"

import "./Recording.vue?vue&type=style&index=0&id=47e84ac6&scoped=true&lang=css"

import exportComponent from "/Users/pkraeutli/development/reca/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e84ac6"]])

export default __exports__